import { useTranslation } from 'react-i18next';

import classNames from 'classnames';

import { Banner } from 'storybook';
import { getOrderLabel, getOrdersIdsLabel } from 'utils/functions';

import styles from './FreeRelatedOrdersBanner.module.css';

type FreeRelatedOrdersBannerProps = {
   freeRelatedOrderIds: string[];
   className?: string;
   isClientView?: boolean;
};

const FreeRelatedOrdersBanner = ({
   freeRelatedOrderIds,
   className,
   isClientView,
}: FreeRelatedOrdersBannerProps) => {
   const { t } = useTranslation();

   const orderLabel = getOrderLabel(freeRelatedOrderIds.length);
   const ordersIdsLabel = getOrdersIdsLabel(freeRelatedOrderIds);

   const bannerText = (
      <>
         <p>
            {t('freeRelatedOrdersBanner.mainText', { orderLabel, ordersIdsLabel })}{' '}
            {!isClientView && t('freeRelatedOrdersBanner.supplfierInfo')}
         </p>
         <p>
            {isClientView
               ? t('freeRelatedOrdersBanner.clientHighlight')
               : t('freeRelatedOrdersBanner.supplierHighlight')}
         </p>
      </>
   );

   return (
      <Banner
         fullWidth
         variant="warning"
         className={classNames(styles.banner, className)}
         children={bannerText}
      />
   );
};

export default FreeRelatedOrdersBanner;
